import React from "react";
import { Button } from "@mui/material";
import VideoThumbnail from "../../assets/icons/Videothumbnail.png"; 

import { ProblemSolutionParentContainer ,
  ProblemSolutionSectionTitle,
  ProblemSolutionContainer,
  ProblemSolutionVideoContainer,
  ProblemSolutionVideoThumbnailImg,
  ProblemSolutionContentContainer,
  ProblemSolutionTitle,
  ProblemSolutionDescription,  
  ProblemSolutionPlayButton,
  ProblemSolutionVideoThumbnailContainer,
} from "../../assets/styles/HomeStyles";
import { useNavigate } from "react-router-dom";



const ProblemSolution = () => {
  const navigate = useNavigate();

  return (
    <ProblemSolutionParentContainer>
      <ProblemSolutionSectionTitle>Problem Solution</ProblemSolutionSectionTitle>

      <ProblemSolutionContainer>
        <ProblemSolutionVideoContainer>
        <ProblemSolutionVideoThumbnailContainer>

          <ProblemSolutionVideoThumbnailImg src={VideoThumbnail} alt="Video Thumbnail" />
          <ProblemSolutionPlayButton variant="contained">▶</ProblemSolutionPlayButton>
          </ProblemSolutionVideoThumbnailContainer>

        </ProblemSolutionVideoContainer>

        <ProblemSolutionContentContainer>
          <ProblemSolutionTitle>Secure Your Workplace with iScreening’s Cutting-Edge Solutions</ProblemSolutionTitle>
          <ProblemSolutionDescription>
            Devia is your go-to platform for advanced safety management. It combines real-time monitoring,
            data-driven insights, and efficient communication across departments to create a safer workplace.
          </ProblemSolutionDescription>
          <Button className="custom-button problem-solution-button" variant="contained"  onClick={() => navigate("/contact-us")}>
            Get Demo
          </Button>
        </ProblemSolutionContentContainer>
      </ProblemSolutionContainer>
    </ProblemSolutionParentContainer>
  );
};

export default ProblemSolution;
